<template>
  <div class="delete-dialog">
    <span @click="openDialog()">
      <slot></slot>
    </span>
  </div>
</template>
<script>
export default {
  name: "dalete",
  components: {},
  props: ["title", "ask", "yesText", "noText", "yesBtnClass"],
  data: () => {
    return {
      data_title: "Delete",
      data_ask: "Are you sure?",
      data_yesText: "Yes",
      data_noText: "No",
      is_dialog_open: false,
      yes_btn_class: "",
    };
  },
  mounted() {
    this.data_title = this.title;
    this.data_ask = this.ask;
    this.data_yesText = this.yesText;
    this.data_noText = this.noText;
    this.yes_btn_class = this.yesBtnClass;
  },
  methods: {
    openDialog() {
      this.$confirm({
        title: this.data_title,
        message: this.data_ask,
        button: {
          yes: this.data_noText,
          no: this.data_yesText,
        },
        callback: (confirm) => {
          if (!confirm) {
            this.$emit("onComfirm");
          }
        },
      });
    },
  },
};
</script>
